export const digitealSectors: string[] = [
    "ACCOUNTANT",
    "AGRIBUSINESS",
    "ARCHITECT",
    "ART_SALES",
    "BAILIFF",
    "BANK",
    "BUSINESS_SERVICES",
    "CARWASH",
    "CHEMISTRY",
    "COMPUTER",
    "CONSTRUCTION",
    "DIAMONDS",
    "DOCTOR",
    "EDUCATION",
    "ELECTRONICS",
    "ENERGY",
    "E_GAMING",
    "GAMES_CHANCE",
    "HEALTH",
    "HORECA",
    "LAWYER",
    "LIBERAL_PROFESSION",
    "MACHINERY",
    "METALLURGY",
    "NOTARY",
    "OTHER",
    "PHARMACEUTICAL",
    "PHONE_SHOP",
    "PLASTIC",
    "PUBLIC",
    "PUBLISHING",
    "RETIREE",
    "STUDIES",
    "TAXIS",
    "TELECOM",
    "TEXTILE",
    "TRADE",
    "TRADING_ON_INTERNET",
    "TRANSPORT",
    "USED_PARTS",
    "WOOD",
]

export const digitealOmitSectors: string[] = ["ARCHITECT", "BAILIFF", "NOTARY"]

export const digitealSubSectors: { sector: string; subSectors: string[] }[] = [
    { sector: "BANK", subSectors: ["TRADING_ON_INTERNET"] },
    { sector: "TRADE", subSectors: ["HORECA", "CARWASH", "USED_PARTS", "PHONE_SHOP", "ART_SALES", "DIAMONDS"] },
    { sector: "PUBLISHING", subSectors: ["E_GAMING", "GAMES_CHANCE"] },
    { sector: "LIBERAL_PROFESSION", subSectors: ["LAWYER", "ACCOUNTANT", "DOCTOR"] },
    { sector: "TRANSPORT", subSectors: ["TAXIS"] },
]
